import {
  ChartLineUp,
  Factory,
  FlagCheckered,
  FolderSimple,
  Hammer,
  Images,
  MagnifyingGlass,
  Monitor,
  Package,
  Ruler,
  SealCheck,
  SquaresFour,
  Truck,
  Users,
  FileText,
  type Icon,
} from '@phosphor-icons/react';
import type { FeatureKey, MeasurementStatus, Phase, PositionStatus } from '@sm/api';
import { PHASE_KEYS } from '@sm/core';

import type { Tone } from '@/components/ui/cx';

/** Ikone faza iz dizajna (Panel v2, `PH`). */
export const PHASE_ICON: Record<Phase, Icon> = {
  measuring: Ruler,
  approval: SealCheck,
  production: Factory,
  quality: MagnifyingGlass,
  delivery: Truck,
  installation: Hammer,
  done: FlagCheckered,
};

export const phaseVar = (p: Phase) => `var(--ph${PHASE_KEYS.indexOf(p) + 1})`;

export const POSITION_STATUS_TONE: Record<PositionStatus, Tone> = {
  draft: 'neutral',
  measured: 'ok',
  warning: 'caution',
  confirmed: 'caution',
  locked: 'ok',
};

export const MEASUREMENT_STATUS_TONE: Record<MeasurementStatus, Tone> = {
  draft: 'neutral',
  submitted: 'caution',
  approved: 'ok',
  approved_with_note: 'ok',
  returned: 'danger',
};

export const NAV_ICONS = {
  dashboard: SquaresFour,
  projects: FolderSimple,
  products: Package,
  customers: Users,
  measurements: Ruler,
  photos: Images,
  production: Factory,
  analytics: ChartLineUp,
} as const;

/** Moduli „Uskoro“: ključ flaga -> slug rute, i18n ključ i ikona (iz dizajna). */
export interface SoonModule {
  key: FeatureKey;
  slug: string;
  navKey: string;
  moduleKey: string;
  icon: Icon;
  features: string[];
}

export const SOON_MODULES: SoonModule[] = [
  {
    key: 'installation',
    slug: 'montaza',
    navKey: 'nav.installation',
    moduleKey: 'installation',
    icon: Hammer,
    features: ['crewSchedule', 'handoverRecord', 'defectList', 'clientNotification'],
  },
  {
    key: 'reports',
    slug: 'izvjestaji',
    navKey: 'nav.reports',
    moduleKey: 'reports',
    icon: FileText,
    features: ['monthlyProduction', 'plannedVsActual', 'outputPerCrew', 'scheduledEmail'],
  },
  {
    key: 'inventory',
    slug: 'zalihe',
    navKey: 'nav.inventory',
    moduleKey: 'inventory',
    icon: Package,
    features: ['stockLevels', 'autoReservation', 'minimumStockAlert', 'purchaseOrders'],
  },
  {
    key: 'shopfloor',
    slug: 'pogonski-ekran',
    navKey: 'nav.plantDisplay',
    moduleKey: 'plantDisplay',
    icon: Monitor,
    features: ['liveStations', 'bottleneckAlerts', 'deadlines', 'kioskMode'],
  },
];

/** Flagovi koje administrator vidi u Podešavanja → Funkcije (moduli panela). */
export const PANEL_FEATURE_KEYS: FeatureKey[] = [
  'installation',
  'crm',
  'reports',
  'inventory',
  'shopfloor',
  'lang_de',
];
